import React from 'react';
import { useStrict } from 'mobx';
import MembershipService from '@xo-union/sdk-membership';
import '@xo-union/tk-ui-essentials';
import GLMApp from './glm-app';
import MobileBumper from './components/mobile-bumper';
import Helpers from './utils/helpers';

class App extends React.Component {
  constructor(props, context) {
    super(props, context);
    useStrict(true);
  }

  componentDidMount() {
    const membershipClient = new MembershipService();
    const token = membershipClient.getSessionToken();

    if (!token) {
      window.location.href = '/gs/guest-list';
    }
  }

  render() {
    let weddingPlanningUrl = 'https://qa-beta.theknot.com';

    if (window.location.host === 'www.theknot.com') {
      weddingPlanningUrl = 'https://www.theknot.com';
    }
    return (
      <React.Fragment>
        {Helpers.isMobile() ? <MobileBumper weddingPlanningUrl={weddingPlanningUrl} /> : <GLMApp />}
      </React.Fragment>
    );
  }
}

export default App;
